module.exports = __webpack_public_path__ + "static/media/L.964169c1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/L.svg
// module id = 413
// module chunks = 0